import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/min/locales';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { Typography, ExpansionPanelSummary, ExpansionPanelDetails, ExpansionPanel } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import StarIcon from '@material-ui/icons/Star';


const TaskScheduleOfflinePoints = ({
    taskschedules,
    renderOfflinePoints,
    openModalOfflinePoints,
    handleCloseOfflinePoints,
    currentStatusOfflinePoints,
    openModalOfflinePointsConfirm,
    openModalOfflinePointsConfirmState,
    closeModalOfflinePointsConfirm,
    handleActionOfflinePoints,
    openOfflinePointsApproveAll,
    handleClickOpen,
    handleClose,
    statusPoint,
    descricaoEventOfflinePoint,
    handleChange,
    approveAll,
    loading,
    actionsC,
    isPremium
}) => {

    return (
        <Paper elevation={2} style={{ margin: 10 }}>
            {
                !taskschedules.filter(i => i.typeEventId === 2).length ?
                    (
                        <Typography align="center" style={{ padding: 10 }}> Não há pontos offline com senha inválida no momento.</Typography>
                    ) :
                    <ExpansionPanel style={{ marginTop: 5 }}>
                        <ExpansionPanelSummary expandIcon={<ExpandMore />} IconButtonProps={{ style: { position: 'absolute', right: '14px' } }}>
                            <Typography item md={5}> Existem {taskschedules.filter(i => i.typeEventId === 2).length} pontos offline com senha inválida.</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ display: 'block' }}>
                            {renderOfflinePoints(taskschedules, actionsC, loading)}
                            <div style={{
                                display: 'flex', justifyContent: 'flex-end',
                            }}>
                                <Dialog
                                    open={openModalOfflinePoints}
                                    onClose={handleCloseOfflinePoints}
                                    aria-labelledby="alert-dialog-offline-points"
                                >
                                    <IconButton aria-label="close" style={{ position: 'absolute', right: '1px' }} onClick={handleCloseOfflinePoints}>
                                        <CloseIcon />
                                    </IconButton>

                                    <DialogTitle id="alert-dialog-offline-points">
                                        Ponto offline pendente
                                    </DialogTitle>
                                    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: ' 20px' }}>
                                        <span style={{ fontSize: '1rem', marginBottom: '0.35em' }}>
                                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                                                <strong>Nome: </strong>
                                                <span style={{ fontWeight: '400' }}>{currentStatusOfflinePoints.employee.name} </span>
                                            </h3>
                                        </span>
                                        <span style={{ fontSize: '1rem', marginBottom: '0.35em' }}>
                                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                                                <strong>Horário: </strong>
                                                <span style={{ fontWeight: '400' }}>{(moment(currentStatusOfflinePoints.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm'))} </span>
                                            </h3>
                                        </span>
                                        <span style={{ fontSize: '1rem', marginBottom: '0.35em' }}>
                                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                                                <strong>Data: </strong>
                                                <span style={{ fontWeight: '400' }}>{(moment(currentStatusOfflinePoints.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy'))} </span>
                                            </h3>
                                        </span>
                                        <span style={{ fontSize: '1rem', marginBottom: '0.35em' }}>
                                            <h3 style={{ marginBottom: 0, fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.54)' }}>
                                                <strong>Tipo: </strong>
                                                <span style={{ fontWeight: '400' }}>{currentStatusOfflinePoints.timeclock.type === "I" ? 'Entrada' : 'Saída'} </span>
                                            </h3>
                                        </span>
                                    </div>
                                    {isPremium == true ?
                                        (
                                            <DialogActions>
                                                <Button
                                                    onClick={status => openModalOfflinePointsConfirm("REJEITADO")}
                                                    variant="contained" style={{ backgroundColor: '#F76363', color: '#FFF' }}> Rejeitar Ponto </Button>
                                                <Button
                                                    onClick={status => openModalOfflinePointsConfirm('APROVADO')}
                                                    variant="contained" style={{ backgroundColor: '#46A045', color: '#FFF' }}> Aprovar Ponto </Button>
                                            </DialogActions>
                                        ) :
                                        <DialogActions>
                                            <DialogContentText style={{ fontSize: '14px', color: '#2880ca', marginBottom: '3px' }}>
                                                *Assine o Plano Premium e trate o ponto por aqui.
                                            </DialogContentText>
                                            <Button variant="contained" color="primary" component={Link} to='/assinatura'>
                                                <StarIcon /> FACILITE! SEJA PREMIUM <StarIcon />
                                            </Button>
                                        </DialogActions>
                                    }
                                </Dialog>
                            </div>
                            <Dialog
                                open={openModalOfflinePointsConfirmState}
                                onClose={closeModalOfflinePointsConfirm}
                                aria-labelledby="alert-dialog-tittle-offline-points-confirm"
                                aria-describedby="alert-dialog-description-points-confirm"
                            >
                                <DialogTitle id="alert-dialog-title-offline-points-confirm">
                                    {statusPoint === 'REJEITADO' ?
                                        (
                                            <span>Rejeitar ponto Offline.</span>
                                        ) :
                                        <span>Aprovar ponto Offline.</span>
                                    }
                                </DialogTitle>
                                <DialogTitle id="alert-dialog-description-points-confirm">
                                    Você tem certeza que deseja efetuar esta ação?
                                </DialogTitle>
                                <DialogActions>
                                    <Button
                                        onClick={closeModalOfflinePointsConfirm}
                                        variant="contained"> CANCELAR </Button>
                                    {statusPoint === 'REJEITADO' ?
                                        (
                                            <Button
                                                onClick={item => handleActionOfflinePoints('REJEITADO', currentStatusOfflinePoints)}
                                                variant="contained" color="primary">CONFIRMAR</Button>
                                        ) :
                                        <Button
                                            onClick={item => handleActionOfflinePoints('APROVADO', currentStatusOfflinePoints)}
                                            variant="contained" color="primary">CONFIRMAR</Button>
                                    }
                                </DialogActions>
                            </Dialog>
                            <div style={{
                                display: 'flex', justifyContent: 'flex-end',
                            }}>
                                {isPremium == true ?
                                    (
                                        <Button variant="outlined" onClick={status => handleClickOpen("pointsOffline")} color="primary" style={{ left: '-21px', bottom: ' -8px' }}>
                                            Aprovar Pontos Offline Pendentes
                                        </Button>
                                    ) :
                                    <DialogActions>
                                        <DialogContentText style={{ fontSize: '14px', color: '#2880ca', right: '20px', bottom: '-15px', position: 'relative' }}>
                                            *Assine o Plano Premium para acessar as ações.
                                        </DialogContentText>
                                        <Button variant="contained" color="primary" component={Link} style={{ left: '-21px', bottom: ' -8px' }} to='/assinatura'>
                                            <StarIcon /> RESOLVA AQUI! SEJA PREMIUM <StarIcon />
                                        </Button>
                                    </DialogActions>
                                }
                                <Dialog
                                    open={openOfflinePointsApproveAll}
                                    onClose={status => handleClose("pointsOffline")}
                                    aria-labelledby="alert-dialog-title-aprove-all-offlinePoints"
                                    aria-describedby="alert-dialog-description-aprove-all-offlinePoints"
                                >
                                    <DialogTitle id="alert-dialog-title-aprove-all-offlinePoints">
                                        Aprovar TODOS os pontos offlines pendentes.
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description-aprove-all-offlinePoints">
                                            Confirme a aprovação digitando <b>APROVADO</b> no campo abaixo.
                                        </DialogContentText>
                                    </DialogContent>
                                    <TextField
                                        style={{ margin: '0px 24px 13px 24px' }}
                                        autoFocus
                                        margin="dense"
                                        name="name"
                                        label="Digite aqui"
                                        type="text"
                                        onChange={event => handleChange(event, 'descricaoEventOfflinePoint')}
                                        value={descricaoEventOfflinePoint}
                                        required
                                    // fullWidth
                                    />
                                    <DialogActions>
                                        <Button onClick={status => handleClose("pointsOffline")} style={{ left: '-21px', bottom: ' 9px' }}> CANCELAR </Button>
                                        {descricaoEventOfflinePoint.trim() === "APROVADO" ?
                                            (
                                                <Button onClick={status => approveAll()} variant="contained" color="primary" style={{ left: '-21px', bottom: ' 9px' }}> CONFIRMAR </Button>
                                            ) :
                                            <Button disabled onClick={status => approveAll()} variant="contained" color="primary" style={{ left: '-21px', bottom: ' 9px' }}> CONFIRMAR </Button>
                                        }
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
            }
        </Paper >
    );
};
export default TaskScheduleOfflinePoints;
